const linkGroups = [
  {
    title: '证据归档',
    links: [
      { label: '截图链存档', href: '#archive' },
      { label: '录音原件库', href: '#archive' },
      { label: '视频实拍区', href: '#archive' },
      { label: '聊天记录对照', href: '#archive' },
    ],
  },
  {
    title: '整理工具',
    links: [
      { label: '瓜田黑料时间线锤', href: '#timeline' },
      { label: '文件解析站', href: '#parse' },
      { label: '哈希校验说明', href: '#parse' },
      { label: '热度榜', href: '#rank' },
    ],
  },
  {
    title: '参与方式',
    links: [
      { label: '提交线索', href: '#discuss' },
      { label: '对线区', href: '#discuss' },
      { label: '收藏订阅', href: '#subscribe' },
      { label: '归档提醒', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-800 pt-14 md:pt-20 pb-8">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-background-50 flex items-center justify-center text-primary-800 text-lg">
                <i className="ri-plant-line" />
              </span>
              <div>
                <strong className="block text-lg font-bold text-background-50">瓜田黑料</strong>
                <em className="not-italic text-[11px] tracking-[0.24em] uppercase text-primary-200">
                  Evidence Archive
                </em>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-100/80">
              实锤证据集中存档，截图、录音、视频、聊天记录、文件解析一站看。
              时间线锤整理清晰，吃瓜不怕没证据，收藏这篇随时对线，让黑料无处遁形。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: 'ri-wechat-2-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-mail-line', label: '邮箱' },
                { icon: 'ri-rss-line', label: '更新源' },
              ].map((item) => (
                <a
                  key={item.label}
                  href="#subscribe"
                  aria-label={item.label}
                  className="w-10 h-10 rounded-md border border-primary-600 text-primary-100 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className={item.icon} />
                </a>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <h4 className="text-sm font-semibold text-background-50">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-primary-100/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="text-sm font-semibold text-background-50">说明</h4>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <a
                  href="#parse"
                  className="text-sm text-primary-100/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  免责声明
                </a>
              </li>
              <li>
                <a
                  href="#discuss"
                  className="text-sm text-primary-100/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  隐私处理
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-600/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/70">
            © 2026 瓜田黑料网 · 本站为内容展示示例，全部条目与数据均为演示用途。
          </p>
          <p className="text-xs text-primary-100/70 flex items-center gap-2">
            <i className="ri-shield-check-line" />
            证据留档不覆盖，来源标注不打折
          </p>
        </div>
      </div>
    </footer>
  );
}